import NotificationContext from "@/ContextProviders/NotificationContext/NotificationContextProvider";
import React from "react";
import { CheckCircle, Error } from "@mui/icons-material";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertColor } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import getClientText from "@/app/i18n";

const AlertNotification = ({ ...props }) => {
  const t = getClientText(props.lang, "common");
  const notificationContext = React.useContext(NotificationContext);

  const { message, severity, position, title, titleText } = props;
  const alertTitle = title ?? titleText ?? t[severity];

  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      <Snackbar
        open={true}
        autoHideDuration={10000}
        onClose={notificationContext.hideNotification}
        anchorOrigin={position || { vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={severity as AlertColor}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                notificationContext.hideNotification();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <AlertTitle sx={{ whiteSpace: "pre-line" }}>{alertTitle}</AlertTitle>
          <Box sx={{ whiteSpace: "pre-line" }}>{message}</Box>
        </Alert>
      </Snackbar>
    </Stack>
  );
};

AlertNotification.propTypes = {
  severity: PropTypes.oneOf(["success", "warning", "info", "error"]).isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleText: PropTypes.string,
};

export default AlertNotification;
